/**
 * Gets the data for a placeholder rectangle.
 *
 * @returns {{rectangle: {}}}
 */
export function getPlaceHolderRectangleData() {
  return {
    rectangle: {
      style: {
        color: '#000000',
        opacity: 1,
        rounded: 0,
      },
      border: {
        color: '#000000',
        opacity: 1,
        width: 0,
      }
    }
  };
}
